/**
 * Calls `done` when the element's CSS transition has had time to finish, or straight away when it has none
 * (reduced motion turns transitions off). Returns the timer, to cancel if another gesture starts first.
 */
export function afterTransition(element: HTMLElement, done: () => void): ReturnType<typeof setTimeout> | undefined {
  const seconds = getComputedStyle(element)
    .transitionDuration.split(',')
    .map((value) => Number.parseFloat(value))
    .filter(Number.isFinite)
  const ms = Math.max(0, ...seconds) * 1000
  if (!ms) {
    done()
    return undefined
  }
  return setTimeout(done, ms + 20)
}
